import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/app/[slug]/components/TableofContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/app/home/components/blogCard/SocialShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/AuthorHoverContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogBody"] */ "/home/shehin/backup-07-08-26/components/DynamicText.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/components/RelatedArticleWithSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/BlogDetails/ad@3x copy.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/BlogDetails/ad@3x.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/BlogDetails/Check.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/BlogDetails/tick@2x.png");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/BlogDetails/wepik-export-20230510100753YWWx@2x.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/homePage/FeatureImage.webp");
